export const PHONE_DIAL_CODE_OPTIONS = [
  { dialCode: "+1", label: "+1 (US)", nationalDigitsLength: 10 },
  { dialCode: "+91", label: "+91 (IN)", nationalDigitsLength: 10 },
] as const;

export type PhoneDialCodeOption = (typeof PHONE_DIAL_CODE_OPTIONS)[number];
export type PhoneDialCode = PhoneDialCodeOption["dialCode"];
